<mat-sidenav-container class="beyou-container" [class.beyou-container--chromeless]="!isSidemenuOpen">
  @if (showSideMenu) {
    <!-- Side Nav -->
    <mat-sidenav #sidenav [mode]="'side'" [opened]="true" class="sidenav">

      <!-- Logo -->
      <div class="logo-container">
        <a routerLink="/dashboard"><img src="/assets/svg/logo.svg" alt="Subrise"></a>
      </div>

      <app-environment-info></app-environment-info>
      
      <!-- Menu Tree -->
      <app-side-menu></app-side-menu>
      @if (showVersionInfo) {
        <app-version-info></app-version-info>
      }
    </mat-sidenav>
  }
  
  <!-- Main Content -->
  <mat-sidenav-content>
    <app-shell-bar [showControls]="showSideMenu" [showHelp]="showHelpButton"></app-shell-bar>
    @if (isLoading$ | async) {
      <div class="loader-container">
        <app-loader [message]="'appShell.loadingInitialData' | transloco"></app-loader>
      </div>
    } @else {
      <router-outlet></router-outlet>
    }
  </mat-sidenav-content>
  <!-- End Main Content -->
</mat-sidenav-container>
